import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../lib/queryKeys'
import { getTerms } from '../request/termApis'

import type { ITerms } from '../../model/terms'

const useTermsQuery = (type: string) => {
  return useQuery<ITerms>({
    queryKey: QUERY_KEYS.TERMS.detail(type),
    queryFn: () => getTerms({ type }),
    enabled: !!type,
    throwOnError: false,
  })
}

export default useTermsQuery
